import { useMemo } from 'react';
import { BANNER_PARAMS, BASE_PARAMS } from '../constants';
import { getCalculatedParams, getRandomId } from '../utils';
import { useBooleanState } from '@cian/react-utils';
import { useDidMount } from '@cian/valuation-utils-component';

const prRandom = getRandomId();

interface IParams {
  regionId?: number;
  userIsAgent?: boolean;
  selectedStations: number[];
  selectedRoads: number[];
  placement: 'footer';
}

export interface IAdFoxParams {
  [key: string]: string;
}

export const useAdFoxParams = ({
  regionId,
  userIsAgent,
  selectedStations,
  selectedRoads,
  placement,
}: IParams): IAdFoxParams | null => {
  const { state: isMounted, setTrue: setMounted } = useBooleanState();

  useDidMount(() => {
    setMounted();
  });

  const uniqRoadsId = useMemo(() => {
    const uniqRoadsId: number[] = [];
    selectedRoads.forEach(id => !uniqRoadsId.includes(id) && uniqRoadsId.push(id));

    return uniqRoadsId;
  }, [selectedRoads]);

  return useMemo(() => {
    if (!isMounted || !regionId) {
      return null;
    }

    const randomId = getRandomId();

    return {
      ...BASE_PARAMS,
      ...BANNER_PARAMS[placement],
      pr: prRandom,
      pr1: randomId,
      puid1: 'deal_type_sale',
      puid10: userIsAgent ? 'agent' : 'no_agent',
      puid2: 'offer_suburban',
      puid3: 'sale_type_first',
      puid5: `obl_id_${regionId}`,
      puid34: selectedStations.join(':'),
      puid35: uniqRoadsId.join(':'),
      ...getCalculatedParams(),
    };
  }, [isMounted, regionId, selectedStations, uniqRoadsId, userIsAgent, placement]);
};
